import { LEGACY_STORAGE_KEYS, STORAGE_KEYS } from '../core/storage-keys';

export type CartItem = {
  id: string | number;
  order_item_id?: string | number;
  menu_item_id?: string | number;
  name: string;
  price: number;
  quantity: number;
  extras?: string[];
  extrasTotal: number;
  modifiers?: Array<unknown>;
  modifier_none_groups?: Array<string | number>;
  package_components?: Array<unknown>;
  special_instructions?: string;
};

type CartListener = (items: CartItem[]) => void;

export class CartPersistence {
  private static instance: CartPersistence | null = null;
  private listeners = new Set<CartListener>();

  static getInstance(): CartPersistence {
    if (!CartPersistence.instance) {
      CartPersistence.instance = new CartPersistence();
      CartPersistence.instance.clearLegacyKeys();
    }
    return CartPersistence.instance;
  }

  getCart(): CartItem[] {
    try {
      const raw = window.localStorage.getItem(STORAGE_KEYS.cartItems);
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }

  setCart(items: CartItem[]): void {
    this.persist(Array.isArray(items) ? items : []);
  }

  clearCart(): void {
    this.persist([]);
  }

  addListener(listener: CartListener): () => void {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }

  private persist(items: CartItem[]): void {
    window.localStorage.setItem(STORAGE_KEYS.cartItems, JSON.stringify(items));
    this.listeners.forEach((listener) => listener(items));
  }

  private clearLegacyKeys(): void {
    for (const key of LEGACY_STORAGE_KEYS.cartItems) {
      try {
        window.localStorage.removeItem(key);
      } catch {
        // Ignore storage exceptions in hard-cleanup path.
      }
    }
  }
}
